export default "__VITE_ASSET__403e30bd__"